<template>
  <ContentWrap>
    <el-form :inline="true" :model="query" class="-mb-15px">
      <el-form-item label="状态">
        <el-select v-model="query.status" clearable class="!w-160px">
          <el-option label="待支付" :value="0" />
          <el-option label="待审" :value="1" />
          <el-option label="通过" :value="2" />
          <el-option label="驳回" :value="3" />
          <el-option label="已撤销" :value="4" />
        </el-select>
      </el-form-item>
      <el-form-item label="用户ID">
        <el-input v-model="query.userId" clearable class="!w-140px" />
      </el-form-item>
      <el-form-item>
        <el-button @click="getList"><Icon icon="ep:search" class="mr-5px" />搜索</el-button>
        <el-button @click="reset"><Icon icon="ep:refresh" class="mr-5px" />重置</el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>
  <ContentWrap>
    <el-table v-loading="loading" :data="list" stripe>
      <el-table-column label="申请ID" prop="id" width="90" />
      <el-table-column label="用户" min-width="140">
        <template #default="{ row }">{{ row.userNickname || '-' }}（{{ row.userId }}）</template>
      </el-table-column>
      <el-table-column label="姓名" prop="realName" width="100" />
      <el-table-column label="电话" prop="mobile" width="120" />
      <el-table-column label="资格费" width="100">
        <template #default="{ row }">¥{{ ((row.feeAmount || 0) / 100).toFixed(2) }}</template>
      </el-table-column>
      <el-table-column label="身份证正面" width="100">
        <template #default="{ row }">
          <el-image
            v-if="row.idCardFrontUrl"
            :src="row.idCardFrontUrl"
            style="width: 48px; height: 48px"
            :preview-src-list="[row.idCardFrontUrl]"
            preview-teleported
          />
        </template>
      </el-table-column>
      <el-table-column label="身份证反面" width="100">
        <template #default="{ row }">
          <el-image
            v-if="row.idCardBackUrl"
            :src="row.idCardBackUrl"
            style="width: 48px; height: 48px"
            :preview-src-list="[row.idCardBackUrl]"
            preview-teleported
          />
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100">
        <template #default="{ row }">
          <el-tag
            :type="
              row.status === 1
                ? 'warning'
                : row.status === 2
                  ? 'success'
                  : row.status === 3
                    ? 'danger'
                    : 'info'
            "
            size="small"
          >
            {{ statusText(row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="支付时间" prop="paidTime" min-width="170" />
      <el-table-column label="操作" width="120" fixed="right">
        <template #default="{ row }">
          <el-button
            v-if="row.status === 1"
            link
            type="warning"
            v-hasPermi="['bosscircle:dist-apply:audit']"
            @click="openAudit(row)"
          >
            审核
          </el-button>
          <el-button v-else link type="primary" @click="openAudit(row, true)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:page="query.pageNo"
      v-model:limit="query.pageSize"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <Dialog v-model="auditVisible" :title="audit.readonly ? '分销申请详情' : '分销商资格审核'" width="720px">
    <el-descriptions :column="2" border class="mb-16px" label-width="96px">
      <el-descriptions-item label="申请人" :span="2">
        {{ audit.row?.userNickname || '-' }}（ID {{ audit.row?.userId }}）
      </el-descriptions-item>
      <el-descriptions-item label="姓名">{{ audit.row?.realName || '-' }}</el-descriptions-item>
      <el-descriptions-item label="电话">{{ audit.row?.mobile || '-' }}</el-descriptions-item>
      <el-descriptions-item label="资格费">
        ¥{{ ((audit.row?.feeAmount || 0) / 100).toFixed(2) }}
      </el-descriptions-item>
      <el-descriptions-item label="统一订单">{{ audit.row?.tradeOrderId || '-' }}</el-descriptions-item>
      <el-descriptions-item label="身份证正面" :span="2">
        <el-image
          v-if="audit.row?.idCardFrontUrl"
          :src="audit.row.idCardFrontUrl"
          class="!h-100px !w-160px"
          fit="contain"
          :preview-src-list="[audit.row.idCardFrontUrl]"
          preview-teleported
        />
        <span v-else>-</span>
      </el-descriptions-item>
      <el-descriptions-item label="身份证反面" :span="2">
        <el-image
          v-if="audit.row?.idCardBackUrl"
          :src="audit.row.idCardBackUrl"
          class="!h-100px !w-160px"
          fit="contain"
          :preview-src-list="[audit.row.idCardBackUrl]"
          preview-teleported
        />
        <span v-else>-</span>
      </el-descriptions-item>
      <el-descriptions-item label="支付时间">{{ audit.row?.paidTime || '-' }}</el-descriptions-item>
      <el-descriptions-item label="当前状态">{{ statusText(audit.row?.status) }}</el-descriptions-item>
      <el-descriptions-item label="驳回原因" :span="2">{{
        audit.row?.rejectReason || '-'
      }}</el-descriptions-item>
    </el-descriptions>
    <template v-if="!audit.readonly && audit.row?.status === 1">
      <el-divider content-position="left">审核操作</el-divider>
      <el-form label-width="96px">
        <el-form-item label="审核结果">
          <el-radio-group v-model="audit.pass">
            <el-radio :value="true">通过</el-radio>
            <el-radio :value="false">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="!audit.pass" label="驳回原因" required>
          <el-input
            v-model="audit.rejectReason"
            type="textarea"
            :rows="3"
            maxlength="200"
            show-word-limit
            placeholder="请填写驳回原因"
          />
        </el-form-item>
      </el-form>
    </template>
    <template #footer>
      <el-button @click="auditVisible = false">{{ audit.readonly ? '关闭' : '取消' }}</el-button>
      <el-button
        v-if="!audit.readonly && audit.row?.status === 1"
        type="primary"
        :loading="audit.saving"
        @click="submitAudit"
      >
        提交审核
      </el-button>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import * as Api from '@/api/business/distApply'

defineOptions({ name: 'BusinessDistApply' })

const message = useMessage()
const loading = ref(false)
const list = ref<Api.DistApplyVO[]>([])
const total = ref(0)
const query = reactive({
  pageNo: 1,
  pageSize: 10,
  /** 默认展示全部，避免小程序已提交但仍为「待支付」时后台看不到 */
  status: undefined as number | undefined,
  userId: undefined as number | undefined
})

const statusText = (s?: number) =>
  ({ 0: '待支付', 1: '待审', 2: '通过', 3: '驳回', 4: '已撤销' } as Record<number, string>)[s ?? -1] ||
  '-'

const getList = async () => {
  loading.value = true
  try {
    const params = {
      ...query,
      userId: query.userId ? Number(query.userId) : undefined
    }
    const data = await Api.getDistApplyPage(params)
    list.value = data?.list || []
    total.value = data?.total || 0
  } finally {
    loading.value = false
  }
}

const reset = () => {
  query.pageNo = 1
  query.status = undefined
  query.userId = undefined
  getList()
}

const auditVisible = ref(false)
const audit = reactive({
  row: undefined as Api.DistApplyVO | undefined,
  pass: true,
  rejectReason: '',
  saving: false,
  readonly: false
})

const openAudit = (row: Api.DistApplyVO, readonly = false) => {
  audit.row = row
  audit.pass = true
  audit.rejectReason = ''
  audit.readonly = readonly || row.status !== 1
  auditVisible.value = true
}

const submitAudit = async () => {
  if (!audit.row?.id) return
  if (!audit.pass && !audit.rejectReason.trim()) {
    message.warning('请填写驳回原因')
    return
  }
  audit.saving = true
  try {
    await Api.auditDistApply({
      id: audit.row.id,
      pass: audit.pass,
      rejectReason: audit.pass ? undefined : audit.rejectReason.trim()
    })
    message.success(audit.pass ? '已通过' : '已驳回')
    auditVisible.value = false
    await getList()
  } finally {
    audit.saving = false
  }
}

onMounted(getList)
</script>
